import * as React from 'react';
import { sortPartialDate, isPartialDate, partialDateToValue } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { useIntl } from 'react-intl';
import { filterByDocumentType } from 'Utility/documentHandling';
import type { TRelevantDocumentType } from '../utils';

const NotesDash = ({ documents }: IOwnProps): React.JSX.Element | undefined => {
  const notes = filterByDocumentType(documents, 'notes')
    .sort((n1, n2) => n2._cdate - n1._cdate)
    .sort((n1, n2) => sortPartialDate(n2.date, n1.date));

  const currentNinmtTreatmentPeriod = filterByDocumentType(documents, 'ninmtTreatmentPeriod')
    .sort((n1, n2) => n2._cdate - n1._cdate)
    .sort((n1, n2) => sortPartialDate(n2.date, n1.date))[0];

  const notesCurrentPeriod = notes.filter(
    n => partialDateToValue(n.date) >= partialDateToValue(currentNinmtTreatmentPeriod?.date),
  );

  const { formatMessage } = useIntl();
  return (
    <TileContentMaker
      type="specificListMultipleRows"
      data={notesCurrentPeriod.map(d => ({
        key: d._id,
        date: isPartialDate(d.date) ? formatPartialDate(d.date) : '',
        title: (
          <div>
            {formatMessage({ id: 'notes.neuroModulationOtherDetails' })}
            <div
              style={{
                fontSize: '1.6rem',
                fontWeight: 600,
                maxHeight: '16rem',
                overflow: 'hidden',
                display: '-webkit-box', // Just to display ellipsis after multiple rows
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 8,
                whiteSpace: 'pre-wrap',
              }}
            >
              {d.neuroModulationOtherDetails ?? '-'}
            </div>
          </div>
        ),
      }))}
      itemsCanFitAmount={1}
    />
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<TRelevantDocumentType>>;
}

export default NotesDash;
